<template>
  <div v-if="open" class="confirm-overlay">
    <div class="confirm-card">
      <div class="confirm-title">Deseja excluir "{{ label }}"?</div>
      <div class="confirm-actions">
        <button class="link link-inline confirm-link" type="button" :disabled="saving" @click="$emit('confirm')">
          {{ saving ? 'Excluindo...' : 'Excluir' }}
        </button>
        <button class="link link-inline confirm-link" type="button" :disabled="saving" @click="$emit('cancel')">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ConfirmDeleteModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm', 'cancel']
})
</script>

<style scoped lang="scss">
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  display: grid;
  place-items: center;
  z-index: 60;
}

.confirm-card {
  min-width: min(560px, calc(100vw - 32px));
  background: #4f3300;
  color: #f3ede3;
  border-radius: 14px;
  border: 1px solid rgba(243, 237, 227, 0.2);
  padding: 18px 20px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25);
}

.confirm-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 14px;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 14px;
}

.link {
  background: transparent;
  border: none;
  cursor: pointer;
  &:disabled { opacity: .6; cursor: default; }
}

.link-inline {
  padding: 6px 10px;
}

.confirm-link {
  color: #f3ede3;
}

.confirm-link:hover {
  color: #b8dbff;
}
</style>
